<template>
    <div class="categorias">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="products_list" title="Agregar producto">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <table>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Estado</th>
                            <th>Precio</th>
                            <th>Cantidad</th>
                            <th>Detalles</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product, index) in productsCategory" :key="index">
                            <td>{{product.name}}</td>
                            <td>{{product.status === 'available' ? 'Disponible' : 'No disponible' }}</td>
                            <td>{{priceFormat(product.price)}}</td>
                            <td @click="$refs.inventory_modal.show()" class="price">{{product.unidades}}</td>
                            <td><button @click="$router.push('/productos/' + product.name + '/profile')">Ver más</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="addProductModal" title="Agregar producto">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Agregar producto a {{category_name}}</h3>
                <div>
                    <label for="">Nombre</label>
                    <input type="text" v-model="product_name">
                </div>
                <div>
                    <label for="">Precio</label>
                    <input type="number" min="0.00" max="10000.00" step="50" v-model="product_price">
                </div>
                <input type="file" ref="select_file_product" name="photo" @change="imgSelected = !imgSelected" class="register-file" accept="image/gif, image/jpeg, image/jpg, image/png, image/bmp" />
                <div v-if="!imgSelected">
                    <label for="">Selecciona una imagen</label>
                    <button @click="$refs.select_file_product.click()"><i class="fa-solid fa-upload"></i></button>
                </div>
                <div v-if="imgSelected" class="selected-img">
                    <center>
                        <h5>Se ha seleccionado la imagen</h5><button @click="imgSelected = false">Cambiar</button>
                    </center>
                </div>
                <button @click="addProduct">Agregar producto</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="changeNameCategory" title="Cambiar nombre">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Cambiar nombre de la categoria {{this.category_name}}</h3>
                <div>
                    <label for="">Nuevo nombre</label>
                    <input type="text" v-model="new_name_category">
                </div>
                <button @click="changeName()">Cambiar nombre</button>
            </div>
        </b-modal>
        <div>
            <div class="column">
                <div class="form">
                    <center>
                        <h3>Crear Categoria</h3>
                        <div>
                            <label for="">Nombre categoria:</label>
                            <input type="text" v-model="NombreCategoria">
                        </div>
                        <button @click="AddCategory">Agregar categoria</button>
                    </center>
                </div>
                <div class="info">
                    <center>
                        <h3>Informacion de La categoria</h3>
                    </center>
                    <div>
                        <div class="info-catego">
                            <center><h5>Informacion General</h5></center>
                            <div>
                                <label for="">Nombre Categoria: <span>{{category_name}}</span></label>
                            </div>
                            <div>
                                <label for="">Cantidad de productos: <span>{{products_cant}}</span></label>
                            </div>
                            <div>
                                <label for="">Stock productos: <span>{{stock_category}}</span></label>
                            </div>
                            <div>
                                <label for="">Ventas hoy: <span>{{priceFormat(category_Sell)}}</span></label>
                            </div>
                        </div>
                        <div class="product-list">
                            <center><h5>productos mas vendidos en la semana</h5>
                                <div class="table-product">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Cantidad Vendidos</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in lastSells" :key="index">
                                                <td>{{item.name}}</td>
                                                <td>{{item.cantidad}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </center>
                        </div>
                    </div>
                    <div>
                        <div class="button">
                            <button @click="getProductsCategoryList">Ver lista de productos</button>
                        </div>
                        <div class="button">
                            <button @click="$refs.addProductModal.show()">Agregar producto</button>
                        </div>
                        <div class="button">
                            <button @click="$refs.changeNameCategory.show()">Cambiar Nombre</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="catego-list">
                <center>
                    <h3>Lista de Categorias</h3>
                    <div>
                        <div v-for="(item, index) in categoriesList" :key="index" :class="{'select': item.select}">
                            <td class="text" @click="getCategory(item)">{{item.name}}</td>
                            <td class="delete" @click="deleteCategory(item.id)">X</td>
                        </div>
                    </div>
                </center>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'
import Notify from '@/utils/Notification.js'

export default {
    name: 'categoritas',
    data() {
        return {
            NombreCategoria: null,
            categoriesList: [],
            products_cant: 0,
            cateroty_id: null,
            category_Sell: 0.00,
            category_name: null,
            stock_category: null,
            new_name_category: null,
            lastSells: [],
            product_name: null,
            product_price: null,
            imgSelected: false,
            productsPicture: null,
            productsPictureObject: null,
            productsCategory: []
        }
    },
    methods: {
        priceFormat: function(item) {
            return Price(item)
        },
        getProductsCategoryList() {
            API.getProductsCategoryList(this.category_name)
                .then((res) => {
                    this.productsCategory = res
                    this.$refs.products_list.show()
                })
        },
        addProduct() {
            API.addProduct(this.category_name, {name: this.product_name, price: this.product_price})
                .then((res) => {
                    this.productUpdatePhoto(res.id)
                    Notify('dirty', 'Se ha agregado el producto con exito')
                })
        },
        uploadFile() {
            this.Images = this.$refs.file.files[0]
        },
        productUpdatePhoto (id) {
            var file = this.$refs.select_file_product.files
            if (!file.length) {
                return
            }

            this.saveImage(file[0], () => {
                API.productUpdatePhoto(this.productsPictureObject, id)
                    .then(result => {
                        this.$router.push('/productos/' + this.product_name + '/profile')
                        Notify('dirty', 'Se ha cambiado la imgen del producto con exito')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            })
        },
        saveImage (file, cb) {
            var reader = new FileReader()
            var vm = this
            reader.onload = (e) => {
                if (file.type === 'image/gif') {
                    vm.productsPicture = e.target.result
                    vm.productsPictureObject = file
                    if (cb) {
                        var toSend = {}
                        toSend.src = vm.productsPicture
                        cb(toSend)
                    }
                } else {
                    var image = new Image()
                    image.src = e.target.result
                    var width = 0
                    var height = 0
                    image.onload = function() {
                        width = this.width
                        height = this.height
                        var canvas = document.createElement('canvas')
                        var ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0)
                        var maxWidth = 400
                        var maxHeight = 400
                        if (width > height) {
                            if (width > maxWidth) {
                                height *= maxWidth / width
                                width = maxWidth
                            }
                        } else {
                            if (height > maxHeight) {
                                width *= maxHeight / height
                                height = maxHeight
                            }
                        }
                        canvas.width = width
                        canvas.height = height
                        ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0, width, height)
                        vm.productsPicture = canvas.toDataURL(file.type)
                        var byteString
                        if (vm.productsPicture.split(',')[0].indexOf('base64') >= 0) {
                            byteString = atob(vm.productsPicture.split(',')[1])
                        } else {
                            byteString = unescape(vm.productsPicture.split(',')[1])
                        }
                        var mimeString = vm.productsPicture.split(',')[0].split(':')[1].split(';')[0]
                        var ia = new Uint8Array(byteString.length)
                        for (var i = 0; i < byteString.length; i++) {
                            ia[i] = byteString.charCodeAt(i)
                        }
                        try {
                            vm.productsPictureObject = new File([new Blob([ia], {type: mimeString})], file.type)
                        } catch (err) {
                            vm.productsPictureObject = new Blob([ia], {type: mimeString})
                            vm.productsPictureObject.name = file.name
                            vm.productsPictureObject.lastModifiedDate = new Date()
                        }

                        if (cb) {
                            cb(image)
                        }
                    }
                }
            }
            reader.readAsDataURL(file)
        },
        changeName() {
            this.$refs.changeNameCategory.hide()
            API.changeName(this.cateroty_id, this.new_name_category)
                .then((res) => {
                    this.getCategory(this.cateroty_id, res)
                    Notify('dirty', 'Se ha cambiado el nombre de la clase con exito')
                })
        },
        deleteCategory(id) {
            API.deleteCategory(id)
                .then((res) => {
                    if (!res) {
                        throw Error(res)
                    }
                    Notify('dirty', 'Se ha eliminado la categoria con exito')
                })
                .catch(() => {
                    Notify('error', 'Asegurate de que la categoria no tendra productos registrados')
                })
        },
        getCategories() {
            API.getCategories()
                .then((res) => {
                    this.categoriesList = res
                    this.getCategory(res[0])
                })
        },
        getCategory(item) {
            this.categoriesList.map(item => { item.select = false })
            API.getCategory(item.id)
                .then((res) => {
                    item.select = true
                    this.cateroty_id = item.id
                    this.category_name = item.name
                    this.category_Sell = res.ventas
                    this.stock_category = res.stock
                    this.products_cant = res.cant
                    this.lastSells = res.Lastsells
                })
        },
        AddCategory() {
            if (this.NombreCategoria == null) {
                return
            }
            API.createCategory(this.NombreCategoria)
                .then((res) => {
                    this.getCategories()
                    this.NombreCategoria = null
                })
        }
    },
    mounted() {
        this.getCategories()
    }
}
</script>

<style scoped>
    .categorias{
        background-color: #cdcdcd;
        height: 90vh;
        padding: 30px;
        color: #000;
    }
    .categorias > div {
        display: flex;
        height: 100%;
    }
    .categorias > div > .column {
        width: 80%;
        height: 100%;
    }
    h3 {
        color: #fff;
    }
    .form {
        background-color: #63b763;
        width: 100%;
        height: 25%;
        margin-right: 15px;
        border-radius: 20px;
        padding: 20px;
    }
    .form > center > div {
        margin: 30px;
    }
    .form > center > div > label {
        margin-right: 20px;
        color: #fff;
        font-size: 20px;
    }
    .form > center > div > input {
        border-radius: 15px;
        width: 250px;
        text-align: center;
        height: 40px;
    }
    .form > center > button {
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .catego-list {
        background-color: #8363b7;
        height: 100%;
        width: 40%;
        margin-left: 15px;
        border-radius: 20px;
        padding: 20px;
        color: #fff;
    }
    .catego-list > center  {
        height: 90%;
    }
    .catego-list > center > div {
        width: 100%;
        padding: 20px;
        margin-top: 30px;
        overflow: auto;
        height: 100%;
    }
    .catego-list > center > div > div {
        width: 100%;
        padding: 10px;
        margin-top: 15px;
        background-color: #2b2926;
        border-radius: 15px;
    }
    .catego-list > center > div > div:hover {
        -webkit-box-shadow: 5px 5px 15px 5px #000000;
        box-shadow: 5px 5px 15px 5px #000000;
    }
    .catego-list > center > div > div:hover {
        background-color: #fff;
    }
    .catego-list > center > div > .select {
        background-color: #63b763;
    }
    .catego-list > center > div > div:hover td {
        color: #2b2926;
    }
    .catego-list > center > div > div > td.text {
        width: 97%;
        text-align: left;
        cursor: pointer;
    }
    .catego-list > center > div > div > td.delete {
        width: 97%;
    }
    .catego-list > center > div > div > td.delete:hover {
        color: red;
        cursor: pointer;
    }
    .info {
        background-color: #63b1b7;
        margin-top: 30px;
        width: 100%;
        margin-right: 15px;
        border-radius: 20px;
        padding: 20px;
        height: 71%;
    }
    .info > div {
        display: flex;
    }
    .info > div > .info-catego{
        width: 50%;
        padding: 10px;
        color: #fff;
        border-right-style: groove;
        border-bottom-style: groove;
    }
    .info-catego > center > h5 {
        border-bottom-style: groove;
    }
    .info > div > .info-catego > div{
        margin: 20px;
    }
    .info > div > .info-catego > div > label {
        width: 100%;
        position: relative;
    }
    .info > div > .info-catego > div > label > span{
        font-weight: bold;
        text-decoration: underline;
        color: #000;
        position: absolute;
        right: 0;
    }
    .info > div > .button {
        padding: 20px;
        width: 100%;
    }
    .info > div > .button > button{
        background-color: #e0b059;
        color: #fff;
        width: 100%;
        height: 40px;
        border-radius: 30px;
    }
    .info > div > .product-list{
        width: 50%;
        padding: 10px;
        color: #fff;
        border-bottom-style: groove;
    }
    .info > div > .product-list > center > h5{
        border-bottom-style: groove;
    }
    .info > div > .product-list > center > .table-product > table {
        margin-top: 20px;
    }
    .info > div > .product-list > center > .table-product > table > thead > tr{
        width: 100%;
    }
    .info > div > .product-list > center > .table-product > table > thead > tr > th{
        padding-top: 10px;
        padding-left: 40px;
        padding-right: 40px;
        padding-bottom: 10px;
        text-align: center;
        border-style: double;
    }
    .info > div > .product-list > center > .table-product > table > tbody > tr > td{
        color: #000;
        text-align: center;
        padding-top: 10px;
        padding-left: 40px;
        padding-right: 40px;
        padding-bottom: 10px;
        border-style: double;
        border-color: #fff;
    }
    .info-wrapper > h3 {
        color: #000;
    }
    .info-wrapper > div {
        padding-top: 40px;
    }
    .info-wrapper > div > label {
        color: #000;
        font-size: 22px;
        margin-right: 15px;
    }
    .info-wrapper > div > input {
        border-radius: 15px;
        width: 250px;
        text-align: center;
        height: 40px;
    }
    .info-wrapper > input[type=file] {
        display: none;
    }
    .info-wrapper > div > button {
        background-color: #e0b059;
        color: #fff;
        min-width: 50px;
        width: auto;
        height: 50px;
        border-radius: 30px;
    }
    .info-wrapper > div > center > button {
        background-color: #e0b059;
        color: #fff;
        min-width: 50px;
        width: auto;
        height: 50px;
        border-radius: 30px;
    }
    .info-wrapper > button {
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
        margin-top: 30px;
    }
    .info-wrapper > .selected-img {
        background-color: chartreuse;
        padding: 10px;
        border-radius: 20px;
        margin-top: 20px;
    }
    .info-wrapper> table {
        background-color: #3a88b5;
    }
    .info-wrapper > table > thead > tr > th {
        padding: 30px;
        border-style: groove;
    }
    .info-wrapper > table > tbody > tr > td {
        padding-left: 30px;
        padding-right: 30px;
        border-style: groove;
    }
    .info-wrapper > table > tbody > tr > td > button {
        background-color: #e0b059;
        color: #fff;
        min-width: 50px;
        width: auto;
        height: 50px;
        border-radius: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Tienda/Categorias.vue